<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="29.167" y="19" width="3.33333" height="18.3333" fill="#DAD6D4" />
    <rect
      x="-0.416667"
      y="0.416667"
      width="3.33333"
      height="6.66667"
      transform="matrix(-1 0 0 1 23.7497 30.667)"
      fill="#FF7B00"
      stroke="#5C5957"
      stroke-width="0.833333"
    />
    <rect
      x="-0.416667"
      y="0.416667"
      width="3.33333"
      height="3.33333"
      transform="matrix(-1 0 0 1 23.7497 17.75)"
      stroke="#5C5957"
      stroke-width="0.833333"
    />
    <rect
      x="-0.416667"
      y="0.416667"
      width="3.33333"
      height="3.33333"
      transform="matrix(-1 0 0 1 23.7497 11.5)"
      stroke="#5C5957"
      stroke-width="0.833333"
    />
    <rect
      x="-0.416667"
      y="0.416667"
      width="3.33333"
      height="3.33333"
      transform="matrix(-1 0 0 1 23.7497 5.25)"
      stroke="#5C5957"
      stroke-width="0.833333"
    />
    <rect
      x="-0.416667"
      y="0.416667"
      width="2.08333"
      height="3.33333"
      transform="matrix(-1 0 0 1 32.9167 22.333)"
      fill="white"
      stroke="#5C5957"
      stroke-width="0.833333"
    />
    <rect
      x="-0.416667"
      y="0.416667"
      width="2.08333"
      height="3.33333"
      transform="matrix(-1 0 0 1 32.9167 29)"
      fill="white"
      stroke="#5C5957"
      stroke-width="0.833333"
    />
    <rect
      x="-0.416667"
      y="0.416667"
      width="3.33333"
      height="3.33333"
      transform="matrix(-1 0 0 1 17.0837 17.75)"
      stroke="#5C5957"
      stroke-width="0.833333"
    />
    <rect
      x="-0.416667"
      y="0.416667"
      width="3.33333"
      height="3.33333"
      transform="matrix(-1 0 0 1 17.0837 11.5)"
      fill="#FF7B00"
      stroke="#5C5957"
      stroke-width="0.833333"
    />
    <rect
      x="-0.416667"
      y="0.416667"
      width="3.33333"
      height="3.33333"
      transform="matrix(-1 0 0 1 23.7497 24)"
      stroke="#5C5957"
      stroke-width="0.833333"
    />
    <rect
      x="-0.416667"
      y="0.416667"
      width="3.33333"
      height="3.33333"
      transform="matrix(-1 0 0 1 17.0837 5.25)"
      stroke="#5C5957"
      stroke-width="0.833333"
    />
    <path
      d="M36.667 37.3333V19H29.167"
      stroke="#5C5957"
      stroke-width="1.66667"
    />
    <path d="M0 38.166L40 38.166" stroke="#5C5957" stroke-width="2.5" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.3747 2.33301C29.3747 1.29747 28.5352 0.458008 27.4997 0.458008H10.833C9.79748 0.458008 8.95801 1.29747 8.95801 2.33301V15.704C9.71214 15.7957 10.4179 16.0512 11.0413 16.4352V2.54134H27.2913V38.1663H29.3747V2.33301ZM17.3177 28.1663C17.4368 27.6869 17.5001 27.1843 17.5001 26.6664C17.5001 25.7083 17.2835 24.8029 16.8984 23.9997H17.9163V28.1663H17.3177Z"
      fill="#5C5957"
    />
    <path
      d="M11.0085 22.9166L11.1847 21.538C11.201 21.4106 11.2095 21.2801 11.2095 21.1468C11.2095 19.5132 9.92196 18.1889 8.33369 18.1889C6.74542 18.1889 5.45788 19.5132 5.45788 21.1468C5.45788 21.3646 5.48053 21.5753 5.52301 21.7771L5.78083 23.0019L4.6484 23.4645C2.87393 24.1894 1.62346 25.9705 1.62346 28.0485C1.62346 30.7711 3.76937 32.9783 6.41648 32.9783V34.4572C2.97523 34.4572 0.185547 31.5879 0.185547 28.0485C0.185547 25.3441 1.81416 23.031 4.11766 22.09C4.05367 21.786 4.01997 21.4705 4.01997 21.1468C4.01997 18.6964 5.95129 16.71 8.33369 16.71C10.7161 16.71 12.6474 18.6964 12.6474 21.1468C12.6474 21.3447 12.6348 21.5397 12.6104 21.7308C14.8166 22.1727 16.4818 24.1711 16.4818 26.5695C16.4818 29.2922 14.3359 31.4993 11.6888 31.4993L11.6679 31.4993C11.153 32.3266 10.4583 33.0242 9.64048 33.5337V31.7073C10.1086 31.1912 10.0412 31.2991 10.4569 30.7019L10.8833 30.0169L11.674 30.0204L11.6888 30.0204C13.5418 30.0204 15.0439 28.4754 15.0439 26.5695C15.0439 24.8923 13.8791 23.4917 12.3355 23.1825L11.0085 22.9166Z"
      fill="#5C5957"
    />
    <path
      d="M13.8326 29.2412H1.76953C2.11965 30.7704 3.50022 32.9725 6.4205 32.9725C8.31829 32.8828 9.77445 31.9449 10.5781 30.5095L10.8964 30.0119C10.8964 30.0119 11.9786 30.0853 12.6311 29.8814C13.4304 29.6317 13.8326 29.2412 13.8326 29.2412Z"
      fill="#DAD6D4"
    />
    <ellipse
      cx="5.27828"
      cy="31.3252"
      rx="1.01852"
      ry="1.04396"
      fill="#3EA827"
    />
    <rect
      x="7.31543"
      y="24.0176"
      width="1.52778"
      height="13.5714"
      fill="#5C5957"
    />
    <path
      d="M8.33301 28.7154L10.8793 25.0615"
      stroke="#5C5957"
      stroke-width="0.833333"
    />
    <path
      d="M8.33301 30.2813L5.27745 27.1494"
      stroke="#5C5957"
      stroke-width="0.833333"
    />
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
